import { useMutation, type UseMutateFunction } from '@tanstack/react-query';
import { candidateAppService } from '../services/candidate-app.service';
import type {
  RegisterCandidateRequest,
  RegisterCandidateResponse,
} from '../types/candidate-app.types';

export function useRegisterCandidate(shareId: string): {
  registerCandidate: UseMutateFunction<RegisterCandidateResponse, Error, RegisterCandidateRequest>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  reset: () => void;
} {
  const mutation = useMutation({
    mutationFn: (request: RegisterCandidateRequest) =>
      candidateAppService.registerCandidate(shareId, request),
  });

  return {
    registerCandidate: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
